(() => {
  const sampleVariantIds = (window.roastworksSampleVariantIds || []).map(Number);
  if (sampleVariantIds.length === 0) return;

  const isSampleItem = (item) => {
    const markedAsSample = item.properties && String(item.properties._roastworks_sample) === 'true';
    return markedAsSample || sampleVariantIds.includes(Number(item.variant_id));
  };

  const removeOrphanSamples = async () => {
    try {
      const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const sampleItems = cart.items.filter(isSampleItem);
      const qualifyingItems = cart.items.filter((item) => !isSampleItem(item));

      if (sampleItems.length === 0 || qualifyingItems.length > 0) return;

      const updates = {};
      sampleItems.forEach((item) => {
        updates[item.key] = 0;
      });

      const updateResponse = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!updateResponse.ok) return;

      if (window.location.pathname === window.routes.cart_url) {
        window.location.reload();
        return;
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'roastworks-sample-guard' });
      }
    } catch (error) {
      console.error('Roastworks sample cart guard:', error);
    }
  };

  document.addEventListener('DOMContentLoaded', removeOrphanSamples, { once: true });

  document.addEventListener('click', (event) => {
    const checkoutControl = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!checkoutControl) return;

    event.preventDefault();
    removeOrphanSamples().finally(() => {
      window.location.href = '/checkout';
    });
  });
})();
